import { render, staticRenderFns } from "./skor_presensi.vue?vue&type=template&id=24afa345&scoped=true"
import script from "./skor_presensi.vue?vue&type=script&lang=js"
export * from "./skor_presensi.vue?vue&type=script&lang=js"
import style0 from "./skor_presensi.vue?vue&type=style&index=0&id=24afa345&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24afa345",
  null
  
)

export default component.exports